import { ADD_COCAPEX_LIST_ITEM, DELETE_COCAPEX_LIST_ITEM, FETCH_COCAPEX_LIST, UPDATE_COCAPEX_LIST_ITEM } from 'actions/coCapex';

const initialState = {
    isLoading: false,
    coCapexData: [],
  };

  const coCapexListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case FETCH_COCAPEX_LIST.REQUEST: {
        return { ...state, isLoading: true };
      }
      case FETCH_COCAPEX_LIST.SUCCESS: {
        return {
          ...state,
          isLoading: false,
          coCapexData: payload,
        };
      }
      case ADD_COCAPEX_LIST_ITEM.SUCCESS: {
        return {
          ...state,
          isLoading: false,
          coCapexData: [...state.coCapexData, payload],
        };
      }

      case DELETE_COCAPEX_LIST_ITEM.SUCCESS: {
        const updatedCoCapexData = state.coCapexData.filter((item) => item.id !== payload);
        return {
          ...state,
          isLoading: false,
          coCapexData: updatedCoCapexData,
        };
      }

      case UPDATE_COCAPEX_LIST_ITEM.SUCCESS: {
        const updatedCoCapexData = state.coCapexData.map((item) =>
          item.id === payload.id ? { ...item, ...payload } : item
        );
        return {
          ...state,
          isLoading: false,
          coCapexData: updatedCoCapexData,
        };
      }
  
      case FETCH_COCAPEX_LIST.FAIL: {
        return { ...state, isLoading: false };
      }
      default:
        return { ...state };
    }
  }

  export default coCapexListReducer;